import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './historyView.scss';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { User } from '@/types';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import FullHistoryComponent from '../historyComponent/fullHistoryComponent';
import { useGetUsersList } from '@/features/users/api/getProducts';

const FunnelHistoryView: VFC<{
    historyDetailssData?: any;
    selectedFunnel?: any;
    usersListData:any
    productList:any;
}> = ({ historyDetailssData, selectedFunnel, usersListData, productList }) => {
    const { user } = useAuth();
    const [historyDetailss, setHistoryDetails] = useState<any>('')
    const useGetUsersMutation = useGetUsersList();
    const [usersList, setUsersList] = useState<User[]>([]);

    useEffect(() => {
        //getUsersList(1)
        if (historyDetailssData && historyDetailssData.length > 0) {
            setHistoryDetails(historyDetailssData)
        }else{
            setHistoryDetails(null)
        }
    }, [historyDetailssData])

    useEffect(()=>{
        setUsersList(usersListData ? usersListData : []);
    },[usersListData])

    const getUsersList = async (pageIndex: number, reset = false, filter?: any) => {
        const res = await useGetUsersMutation.mutateAsync({
            page: pageIndex,
            perPage: 500,
            search: '',
            filter: { 'rolesId': [1, 2, 3, 4] },
        });
        setUsersList(res.list);

    };


    const getUserName = (userId: any) => {
        const data: any = usersList.filter((item: any) => Number(item.id) === Number(userId))
        if (data && data.length > 0) {
            return data[0].name
        } else {
            return ''
        }

    }


    return (
        <>
            <div className='history-view-details'>
                {historyDetailss && historyDetailss?.length > 0 ? historyDetailss.slice()
                    .sort((a: any, b: any) => new Date(b._at).getTime() - new Date(a._at).getTime())
                    .slice(0, -1)  
                    .slice(0, 2)
                    .map((details: any) => {
                        return (
                            <>
                                <div className='history-view-details mb-4'>
                                    <div className='history-div'>
                                        <div className='history-user-name reduce-font'>
                                            <div className='name-details'>
                                                {details?.updatedBy !== 'xyz' ? getUserName(details?._by) : ''}
                                            </div>
                                            <div className='time-details'>
                                                {Utils.convertTimestampToTimeFormatWithTime(details?._at)}
                                            </div>
                                        </div>
                                        <FullHistoryComponent productList={productList} usersListData={usersListData} details={details} selectedFunnel={selectedFunnel} reduceFont={true} />
                                    </div>
                                </div>
                            </>
                        )
                    }) : <div className='no-updated-yet-1'>No updates yet!</div>}

                {/* <div className='history-div'>
                        <div className='history-user-name'>
                            <div className='name-details'>
                                Harsh Turkar
                            </div>
                            <div className='time-details'>
                                3Aug 2024, 9:12 AM
                            </div>
                        </div>
                        <div className='history-mapping'>
                            <div className='statues-ion'>
                                <Statusicon />
                                <div className='horizontal-line'>
                                </div>
                            </div>
                            <div className='details-div'>
                                <div className='ttile'>
                                    Funnel state updated
                                </div>
                                <div className='display-detail'>
                                    <span>Demo scheduled</span> {"->"} <span className='pro'> Initial interest</span>
                                </div>
                            </div>
                        </div>
                        <div className='history-mapping'>
                            <div className='statues-ion'>
                                <Calendericon />
                                <div className='horizontal-line'>
                                </div>
                            </div>
                            <div className='details-div'>
                                <div className='ttile'>
                                    Funnel state updated
                                </div>
                                <div className='display-detail'>
                                    <span>Demo scheduled</span> {"->"} <span className='pro'> Initial interest</span>
                                </div>
                            </div>
                        </div>
                        <div className='history-mapping'>
                            <div className='statues-ion'>
                                <Coverageicon />
                                <div className='horizontal-line'>
                                </div>
                            </div>
                            <div className='details-div'>
                                <div className='ttile'>
                                    Funnel state updated
                                </div>
                                <div className='display-detail'>
                                    <span>Demo scheduled</span> {"->"} <span className='pro'> Initial interest</span>
                                </div>
                            </div>
                        </div>
                    </div> */}

            </div>
            {/* <div className='footer-overflow'></div> */}


        </>
    );
};




export default FunnelHistoryView;
